import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { HorizontalDropdown } from "@/components/dropdown/HorizontalDropdown";
import { Icon } from "@/components/icons/Icon";
import { Sidebar } from "@/components/sidebar";

import type { CellVerticalAlignment } from "@/components/tiptap/tables/TableCellVerticalAlignment";

type Props = {
  alignment?: CellVerticalAlignment | null;
  onSelect: (alignment: CellVerticalAlignment) => void;
  tooltipTitle?: string;
};

export const TableCellAlignmentDropdown = observer(function TableCellAlignmentDropdown({
  alignment,
  onSelect,
  tooltipTitle,
}: Props) {
  const t = useTranslations("sidebar");

  const items = [
    {
      title: t("tableStyle.alignment.buttons.top"),
      icon: <Icon name="AlignTop" />,
      active: alignment === "top",
      onClick: () => onSelect("top"),
    },
    {
      title: t("tableStyle.alignment.buttons.center"),
      icon: <Icon name="AlignCenter" />,
      active: alignment === "center",
      onClick: () => onSelect("center"),
    },
    {
      title: t("tableStyle.alignment.buttons.bottom"),
      icon: <Icon name="AlignBottom" />,
      active: alignment === "bottom",
      onClick: () => onSelect("bottom"),
    },
  ];
  const activeItem = items.find((item) => item.active);

  return (
    <HorizontalDropdown
      toggleButtonComponent={
        <Sidebar.ToggleButton
          as="div"
          icon={activeItem?.icon || <Icon name="AlignTop" />}
          tooltipTitle={tooltipTitle}
        />
      }
      items={items}
    />
  );
});
